<template>
    <Navagation/>
    <div>
        <title>Create Expense</title>
        <div>
            <h4 class="center-align">Create Expense</h4>
            <br>
            <div class="row">
                <form class="col s12" method="post" enctype="multipart/form-data">
                    <div class="row">
                        <div class="input-field col s6">
                            <textarea v-model="description" id="description" class="materialize-textarea"></textarea>
                            <label for="description">Description</label>
                        </div>
                        <div class="input-field col s6">
                            <select v-model="asset" id="asset">
                                <option value="" disabled selected>Choose your Asset</option>
                                <option value="14282 Greenview Drive">14282 Greenview Drive</option>
                                <option value="14275 Penn Dixie Lane">14275 Penn Dixie Lane</option>
                                <option value="861 Stouffer Avenue">861 Stouffer Avenue</option>
                                <option value="Dodge Ram 3500 Truck">Dodge Ram 3500 Truck</option>
                            </select>
                            <label>Asset</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field col s6">
                            <select v-model="category" id="category">
                                <option value="" disabled selected>Choose your Category</option>
                                <option value="School Tax">School Tax</option>
                                <option value="Property Tax">Property Tax</option>
                                <option value="Maintenance">Maintenance</option>
                                <option value="Insurance">Insurance</option>
                                <option value="Fuel">Fuel</option>
                            </select>
                            <label>Category</label>
                        </div>
                        <div class="input-field col s6">
                            <input v-model="amount" id="amount" type="text" class="validate">
                            <label for="amount">Amount</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field col s12">
                            <label>Date</label>
                            <input v-model.lazy="date" type="text" class="datepicker">
                        </div>
                    </div>
                    <div class="row">
                        <div class="file-field input-field col s12">
                            <div class="btn">
                                <span>File</span>
                                <input type="file" @change="onFileChange">
                            </div>
                            <div class="file-path-wrapper">
                                <input class="file-path validate" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="image">
                        <div class="center-align">
                            <img class="responsive-img" :src="image" />
                        </div>
                        <div class="center-align">
                            <a v-if="!uploadURL" class="waves-effect waves-light btn" @click="removeImage">Remove</a>
                        </div>
                    </div>
                </form>
                <div class="row">
                    <div class="center-align">
                        <a class="waves-effect waves-light btn" @click="submit">Submit</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import M from 'materialize-css'
import axios from "axios"
import Navagation from '@/components/Navagation.vue'



/* ENTER YOUR ENDPOINT HERE */

const API_ENDPOINT = 'https://8c8gylju3m.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage/uploads'

const API_CREATE = 'https://8c8gylju3m.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage/expense'

export default {
    name: "App",
    components: {
        Navagation
    },
    data() {
        return {
            image: '',
            uploadURL: '',
            description: '',
            amount: '',
            asset: '',
            category: '',
            fileID: '',
            date: ''
        }
    },
    mounted () {

        M.AutoInit()
        var elems = document.querySelectorAll('.datepicker');
        M.Datepicker.init(elems);
    },
    methods: {
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            this.createImage(files[0])
            this.fileName = files[0].name;
        },
        submit: async function () {

            // Get File Extension
            var ext = this.fileName.split('.')[1]

            // Get the presigned URL with Extension
            const response = await axios({
                method: 'GET',
                url: API_ENDPOINT + "/" + ext
            });

            let binary = atob(this.image.split(',')[1])
            let array = []
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i))
            }
            let blobData = new Blob([new Uint8Array(array)])

            const formData = new FormData()

            // Loop Through Each Field and Append
            for (const key in response.data.data.fields ) {
                formData.append(key,response.data.data.fields[key]);
            }


            formData.append('file', blobData);

            // Upload File
            const result = await fetch(response.data.data.url, {
                method: 'POST',
                body: formData
            })

            if (result.status == 204) {
                M.toast({ html: 'Image Uploaded Successfully' })
            }
            else {
                M.toast({ html: 'Image Failed to Upload' })
            }
            console.log(result)

            // Create Expense
            const result_create = await fetch(API_CREATE, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    amount: this.amount,
                    description: this.description,
                    date: this.date,
                    asset: this.asset,
                    category: this.category,
                    file: response.data.data.fields['key']
                })
            })

            if (result_create.status == 201) {
                M.toast({ html: 'Expense Created Successfully' })
                setTimeout(() => { window.location = "./"; }, 2300);
            }
            else {
                M.toast({ html: 'Expense Creation Failed' })
            }
            console.log(result_create)

        },
        createImage(file) {
            //var image = new Image()
            let reader = new FileReader()
            reader.onload = (e) => {
                this.image = e.target.result
            }
            reader.readAsDataURL(file)
        },
        removeImage: function () {
            this.image = ''
        }
    }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>